<template>
  <div v-if="konfiguration" class="d-flex flex-wrap mb-4" style="gap: 24px">
    <div v-if="hasDringlichkeit" class="teilnehmer-hint-pill">
      <AlertCircle :size="16" class="mr-2 flex-shrink-0" />
      Dringlichkeit: {{ konfiguration.dringlichkeit }}h
    </div>
    <div v-if="konfiguration.benachrichtigungAnCmVorRelease" class="teilnehmer-hint-pill">
      <AlertCircle :size="16" class="mr-2 flex-shrink-0" />
      Benachrichtigung an CM vor Release
    </div>
  </div>
  <b-alert v-else show variant="warning">
    <i class="flaticon2-warning text-white"></i>
    Keine gültige Konfiguration gefunden!
  </b-alert>
</template>

<script>
import { AlertCircle } from 'lucide-vue';

export default {
  name: 'TeilnehmerHintPills',
  components: { AlertCircle },
  props: {
    konfiguration: { type: Object },
  },
  computed: {
    hasDringlichkeit() {
      return this.konfiguration?.dringlichkeit != null && this.konfiguration?.dringlichkeit !== 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.teilnehmer-hint-pill {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border: 0.5px solid #ffa800;
  border-radius: 8px;
  background-color: #ffa8001a;
  color: #d97706;
  font-weight: 500;
  box-shadow: 0px 1px 3px 0px #0000001a;
}
</style>
